export interface PatternElement {
  label: string;
  value: string;
}

export const allPatterns: PatternElement[] = [
  { label: 'løbenummer (2 cifre)', value: '%<no>02d' },
  { label: 'løbenummer (3 cifre)', value: '%<no>03d' },
  { label: 'løbenummer (4 cifre)', value: '%<no>04d' },
  { label: 'løbenummer (5 cifre)', value: '%<no>05d' },
  { label: 'løbenummer (6 cifre)', value: '%<no>06d' },
  { label: 'kategori', value: '%<category>s' },
  { label: 'årstal, kort', value: '%<short_year>s' },
  { label: 'årstal', value: '%<year>s' },
  { label: 'startårstal', value: '%<start_year>s' },
  { label: 'startårstal, kort', value: '%<short_start_year>s' },
  { label: 'slutårstal', value: '%<end_year>s' },
  { label: 'slutårstal, kort', value: '%<short_end_year>s' },
];
